var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit }) {
          return [
            !_vm.isSuccess
              ? _c(
                  "form",
                  {
                    staticClass: "login-form custom-form m-t-5 p-t-5",
                    attrs: { id: "login-form", novalidate: "" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.onSubmit)
                      }
                    }
                  },
                  [
                    _c("ValidationProvider", {
                      attrs: { mode: "lazy", rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "p-t-5 two-factor-auth-description"
                                  },
                                  [
                                    _c("h1", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "INPUT_TWO_FACTOR_TITLE",
                                          expression: "'INPUT_TWO_FACTOR_TITLE'"
                                        }
                                      ],
                                      staticClass:
                                        "title md-title title--ringba"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "login-form__field two-factor-auth-description"
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "TWO_FACTOR_FORM_APP_INSTRUCTION"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "login-form__field input__wrap",
                                    class: { "error-focus": errors.length > 0 }
                                  },
                                  [
                                    _c("div", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.validationCode,
                                            expression: "validationCode"
                                          }
                                        ],
                                        ref: "validationCodeInput",
                                        staticClass:
                                          "login-form__field__input required",
                                        class: {
                                          error: errors.length > 0,
                                          valid:
                                            _vm.validationCode.length > 0 &&
                                            errors.length == 0
                                        },
                                        attrs: {
                                          id: "validationCode",
                                          disabled: _vm.isPending,
                                          "data-testid": "mfa-code-input",
                                          name: "validationCode",
                                          autocomplete: "one-time-code",
                                          inputmode: "numeric",
                                          required: ""
                                        },
                                        domProps: { value: _vm.validationCode },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) return
                                            _vm.validationCode =
                                              $event.target.value
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        directives: [
                                          {
                                            name: "t",
                                            rawName: "v-t",
                                            value: "INPUT_TWO_FACTOR_CODE",
                                            expression:
                                              "'INPUT_TWO_FACTOR_CODE'"
                                          }
                                        ],
                                        staticClass: "login-form__field__label",
                                        attrs: { for: "userName" }
                                      }),
                                      _vm._v(" "),
                                      errors.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "error-tooltip__wrap"
                                            },
                                            [
                                              _c("h4", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value:
                                                      "INPUT_TWO_FACTOR_CODE_ERROR",
                                                    expression:
                                                      "'INPUT_TWO_FACTOR_CODE_ERROR'"
                                                  }
                                                ],
                                                staticClass:
                                                  "menu-link text-uppercase error-tooltip__content"
                                              }),
                                              _vm._v(" "),
                                              _c("p", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value:
                                                      "INPUT_TWO_FACTOR_CODE_ERROR_DESCRIPTION",
                                                    expression:
                                                      "'INPUT_TWO_FACTOR_CODE_ERROR_DESCRIPTION'"
                                                  }
                                                ],
                                                staticClass: "description"
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _vm.canRememberDevice
                      ? [
                          _c(
                            "fieldset",
                            {
                              staticClass:
                                "login-form__field login-form__field--checkbox login-form__field--remember-device checkbox__wrap"
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.rememberDevice,
                                    expression: "rememberDevice"
                                  }
                                ],
                                staticClass:
                                  "login-form__field__input--checkbox",
                                attrs: {
                                  id: "two-factor.remember-device",
                                  type: "checkbox",
                                  name: "two-factor.remember-device",
                                  "data-testid": "remember-device-checkbox"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.rememberDevice)
                                    ? _vm._i(_vm.rememberDevice, null) > -1
                                    : _vm.rememberDevice
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.rememberDevice,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.rememberDevice = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.rememberDevice = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.rememberDevice = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("label", {
                                directives: [
                                  {
                                    name: "t",
                                    rawName: "v-t",
                                    value: "INPUT_REMEMBER_DEVICE",
                                    expression: "'INPUT_REMEMBER_DEVICE'"
                                  }
                                ],
                                staticClass:
                                  "login-form__field__label login-form__field__label--checkbox",
                                attrs: {
                                  for: "two-factor.remember-device",
                                  "data-testid": "remember-device-label"
                                }
                              })
                            ]
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "fieldset",
                      {
                        staticClass:
                          "login-form__field login-form__field--button"
                      },
                      [
                        _c(
                          "SubmitButton",
                          {
                            attrs: {
                              pending: _vm.isPending,
                              "data-testid": "mfa-submit-button"
                            }
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("VALIDATE_TWO_FACTOR_BUTTON")) +
                                "\n      "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "button button--transparent-grad pulse m-t-10",
                              attrs: { href: "#" },
                              on: { click: _vm.onGoBack }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t(_vm.backButtonDescription)) +
                                  "\n        "
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "transition",
                      { attrs: { name: "backend-error-fade" } },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showErrorMsg,
                                expression: "showErrorMsg"
                              }
                            ],
                            staticClass: "text-center p-t-5"
                          },
                          [
                            _c("p", { staticClass: "text-danger" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.actionStatus.error) +
                                  "\n        "
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("i18n", {
                      staticClass: "p-t-10 two-factor-auth-description",
                      attrs: {
                        path: "TWO_FACTOR_FORM_APP_ADDITIONAL_INSTRUCTION",
                        tag: "div"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "link",
                            fn: function() {
                              return [
                                _c(
                                  "a",
                                  {
                                    staticClass: "home_link",
                                    attrs: {
                                      href:
                                        "https://support.ringba.com/hc/en-us/articles/32715801404823-How-do-I-find-my-MFA-code",
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(
                                          _vm.$t(
                                            "TWO_FACTOR_FORM_APP_ADDITIONAL_INSTRUCTION_LINK"
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                    _c("i", {
                                      staticClass: "fa fa-external-link m-l-1"
                                    })
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }